var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _g3, _path15, _g4, _path16, _path17, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestOfLondonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.34,
    height: 63.034,
    viewBox: "0 0 64.34 63.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_28841",
    "data-name": "Group 28841",
    transform: "translate(0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34201",
    "data-name": "Path 34201",
    d: "M-510.432,542.785V530.339l-3.045-2.371-2.436,8.986v7.188A36.108,36.108,0,0,0-510.432,542.785Z",
    transform: "translate(554.671 -502.794)",
    fill: "#4a9426",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24635",
    "data-name": "Group 24635",
    transform: "translate(5.699 0.37)",
    opacity: 0.17,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24634",
    "data-name": "Group 24634",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34202",
    "data-name": "Path 34202",
    d: "M-866.176,245.351a28.051,28.051,0,0,0-.038-4.741,24.842,24.842,0,0,0-7.4-15.664,10.665,10.665,0,0,0-3.687-2.435,5.267,5.267,0,0,0-4.31.234l-.871.534,0,0a23.466,23.466,0,0,1-6.266,2.962,73.952,73.952,0,0,1-8.992,1.559q-.454.072-.907.153l.173.03-.3.051.132-.081a38.025,38.025,0,0,0-13.834,5.07l-.009.015-.041.025.006-.009c-.222.141-.445.283-.663.43s-.433.3-.647.452l-.1.069q-.322.234-.638.477l-.037.029a22.716,22.716,0,0,0-8.256,11.948,20.549,20.549,0,0,0-.1,9.673c.921.6,1.965,1.227,3.128,1.852a48.765,48.765,0,0,0,23.332,5.654,37.3,37.3,0,0,0,22.574-7.651c.6-.44,1.159-.882,1.693-1.32C-868.825,251.672-866.62,248.146-866.176,245.351Zm-4.93-3.749c0,.026,0,.052,0,.078l0,0Z",
    transform: "translate(923.494 -222.163)",
    fill: "#a5b4c7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34203",
    "data-name": "Path 34203",
    d: "M-916.942,246.719a29.681,29.681,0,0,0-29.675-29.114,29.691,29.691,0,0,0-29.14,24.013c-.916,5.117,2.146,8.449,4.616,10.324.921.6,1.965,1.228,3.129,1.852a48.765,48.765,0,0,0,23.332,5.654,37.3,37.3,0,0,0,22.574-7.651c.6-.442,1.162-.885,1.7-1.324A23.7,23.7,0,0,0-916.942,246.719Z",
    transform: "translate(977.37 -217.605)",
    fill: "#a5b4c7",
    opacity: 0.17,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34204",
    "data-name": "Path 34204",
    d: "M-515.353,544.045l.343-.065.3-.058.345-.071.3-.066.41-.092q.24-.056.479-.114l.326-.083.31-.081.327-.089.327-.092.351-.1q.256-.076.51-.156l.3-.1.332-.109.3-.1.362-.127.273-.1q.278-.1.554-.207l.268-.1.36-.143.271-.11q.2-.084.407-.171l.207-.088q.288-.125.575-.255l.237-.109.388-.182.24-.115q.229-.111.457-.225l.15-.075q.292-.148.582-.3l.209-.111q.206-.11.412-.223l.211-.116q.255-.142.508-.288l.091-.052q.294-.171.586-.348l.187-.114q.214-.131.427-.264l.188-.118q.276-.175.55-.355l.04-.026q.293-.193.584-.393l.173-.12q.217-.15.433-.3l.173-.122q.29-.208.579-.421h0q.2-.152.4-.3l.054-.041q.191-.145.377-.29l.063-.049q.186-.146.368-.291l.046-.037q.19-.153.376-.3c.042-.541.116-1.517.141-2.016l-15.9-5.687-2.436,8.986v7.188h0Q-515.631,544.1-515.353,544.045Z",
    transform: "translate(554.67 -502.794)",
    fill: "#4f9f28",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34205",
    "data-name": "Path 34205",
    d: "M-805.78,314.8l2.577,1.794-1.749,1.979,1.012.322-.805,8.453a50.468,50.468,0,0,0,16.406,2.638,36.879,36.879,0,0,0,7.094-.682l-2.724-15.343,1.1-1.7-1.887-.6,1.667-3.775-3.185-1.13-.254-3.644-2.563-2.29,2.475,1.031,1.446-1.954-13.022-5.522-5.729,11,1.864.506v3.588Z",
    transform: "translate(821.027 -288.139)",
    fill: "#ffb200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34206",
    "data-name": "Path 34206",
    d: "M-452.323,406.95V395.9s-.107-.947,1.046-.947a1.292,1.292,0,0,1,1.052.48,1.517,1.517,0,0,1,.322.922l.3,11.758",
    transform: "translate(496.241 -380.566)",
    fill: "#4f9f28",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34207",
    "data-name": "Path 34207",
    d: "M-485.878,527.968l3.045,2.371,12.78,4.42.072-1.1Z",
    transform: "translate(527.073 -502.794)",
    fill: "#468c24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34208",
    "data-name": "Path 34208",
    d: "M-805.78,314.8l2.577,1.357-1.749,2.416,1.012.322-.805,8.453a48.014,48.014,0,0,0,7.142,1.839V297.262l-.585-2.9-5.729,11,1.864.506v3.588Z",
    transform: "translate(821.027 -288.139)",
    fill: "#fb9700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34209",
    "data-name": "Path 34209",
    d: "M-805.78,409.479l2.577,1.794,5.6-9.059v-4.808h0l-4.451,6.734Z",
    transform: "translate(821.027 -382.822)",
    fill: "#f58500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34210",
    "data-name": "Path 34210",
    d: "M-780.94,305.869l4.451-8.607-.585-2.9-5.729,11,1.864.506",
    transform: "translate(799.914 -288.139)",
    fill: "#f58500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34211",
    "data-name": "Path 34211",
    d: "M-536.87,535.918",
    transform: "translate(573.928 -510.099)",
    fill: "#ed6800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34212",
    "data-name": "Path 34212",
    d: "M-788.219,457.721l-6.337,9.552-1.012-.759,7.35-11.145Z",
    transform: "translate(811.644 -436.084)",
    fill: "#ed6800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34213",
    "data-name": "Path 34213",
    d: "M-546.514,517.89",
    transform: "translate(582.79 -493.534)",
    fill: "#ffb200"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34214",
    "data-name": "Path 34214",
    d: "M-890.851,354.592l4.184-9.953-5,9.079-9.9-10,9.235,11.06-6.365,12.891,7.144-11.927,11.279,10.889Z",
    transform: "translate(909.042 -333.487)",
    fill: "#00afec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34215",
    "data-name": "Path 34215",
    d: "M-429.558,777.68",
    transform: "translate(475.321 -732.252)",
    fill: "#cc006c",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34216",
    "data-name": "Path 34216",
    d: "M-783.087,596.748",
    transform: "translate(800.174 -565.995)",
    fill: "#f58500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34217",
    "data-name": "Path 34217",
    d: "M-711.587,297.262l10.991,4.579,1.446-1.954-13.022-5.522Z",
    transform: "translate(735.012 -288.139)",
    fill: "#f58500",
    opacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24636",
    "data-name": "Group 24636",
    transform: "translate(0 36.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34218",
    "data-name": "Path 34218",
    d: "M-986.747,692.324l-3.511-2.042,3.372-5.8a.2.2,0,0,0-.067-.252l-2.075-1.206a.2.2,0,0,0-.252.067l-4.455,7.66a.2.2,0,0,0,.067.252l5.745,3.341a.261.261,0,0,0,.294-.078l.959-1.649A.261.261,0,0,0-986.747,692.324Z",
    transform: "translate(993.756 -681.781)",
    fill: "#141e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34219",
    "data-name": "Path 34219",
    d: "M-879.763,747.087c-1,2.811-3.851,3.689-6.488,2.746s-4.282-3.426-3.277-6.237,3.851-3.689,6.488-2.746S-878.759,744.277-879.763,747.087Zm-7.157-2.558a2.347,2.347,0,0,0,1.456,3.1,2.347,2.347,0,0,0,3.093-1.476,2.356,2.356,0,0,0-1.457-3.1A2.356,2.356,0,0,0-886.921,744.53Z",
    transform: "translate(898.257 -734.602)",
    fill: "#141e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34220",
    "data-name": "Path 34220",
    d: "M-749.59,775.467c-.372-.483-.781-1.156-.781-1.156l-.061-.008-.616,4.746a.2.2,0,0,1-.207.159l-2.38-.309a.2.2,0,0,1-.159-.207l1.142-8.789a.2.2,0,0,1,.207-.159l2.06.267,3.406,4.477a12.4,12.4,0,0,1,.716,1.055l.046.006.615-4.73a.2.2,0,0,1,.207-.159l2.38.309a.2.2,0,0,1,.159.207L-744,779.964a.2.2,0,0,1-.207.159l-2.06-.268Z",
    transform: "translate(773.259 -761.484)",
    fill: "#141e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34221",
    "data-name": "Path 34221",
    d: "M-605.406,789.843a.2.2,0,0,1-.2-.166l-.834-8.822a.2.2,0,0,1,.167-.2l3.982-.376c3.017-.285,5.331,1.3,5.6,4.107.261,2.757-1.373,4.766-4.7,5.08Zm1.925-7.1.428,4.534,1.425-.135a2.111,2.111,0,0,0,2.175-2.493,2.187,2.187,0,0,0-2.619-2.039Z",
    transform: "translate(637.857 -771.134)",
    fill: "#141e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34222",
    "data-name": "Path 34222",
    d: "M-465.029,751.329c.957,2.828-.73,5.283-3.382,6.181s-5.484-.028-6.441-2.856.73-5.283,3.382-6.181S-465.986,748.5-465.029,751.329Zm-7.2,2.437a2.347,2.347,0,0,0,3.068,1.528,2.348,2.348,0,0,0,1.509-3.077,2.356,2.356,0,0,0-3.068-1.528A2.356,2.356,0,0,0-472.228,753.766Z",
    transform: "translate(517.189 -741.637)",
    fill: "#141e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34223",
    "data-name": "Path 34223",
    d: "M-355.892,675.561l5.333,1.366,1.779-1.073a.2.2,0,0,0,.063-.253l-4.576-7.589a.2.2,0,0,0-.254-.063l-2.055,1.239a.2.2,0,0,0-.063.254l2.463,4.084-.039.024a12.416,12.416,0,0,0-1.217-.38l-5.452-1.384-1.779,1.072a.2.2,0,0,0-.063.254l4.576,7.589a.2.2,0,0,0,.254.063l2.055-1.239a.2.2,0,0,0,.063-.253l-2.471-4.1.053-.032S-356.483,675.415-355.892,675.561Z",
    transform: "translate(413.035 -667.927)",
    fill: "#141e45"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24637",
    "data-name": "Group 24637",
    transform: "translate(15.597 52.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34224",
    "data-name": "Path 34224",
    d: "M-800.9,923.668c.073.018.084.056.069.116-.125.489.138.893,1.036,1.122.819.209,1.2-.061,1.3-.477.061-.238-.014-.524-.539-.7l-1.083-.36c-.782-.27-1.048-.717-.906-1.272.153-.6.84-1.115,1.995-.82,1.228.313,1.527.987,1.354,1.667-.008.033-.043.059-.116.041l-.389-.1c-.066-.017-.087-.043-.07-.138.055-.352-.133-.772-.906-.969-.68-.173-1.179.044-1.286.467-.061.237.046.483.506.635l1.063.355c.886.3,1.09.827.959,1.342-.136.535-.771,1.146-2.012.83-1.208-.308-1.677-1.032-1.5-1.726l.017-.066c.012-.046.038-.068.1-.052Z",
    transform: "translate(801.463 -916.354)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34225",
    "data-name": "Path 34225",
    d: "M-742.36,936.188a2.067,2.067,0,0,1-2.526,1.718,2.071,2.071,0,0,1-1.828-2.448,2.071,2.071,0,0,1,2.526-1.718A2.064,2.064,0,0,1-742.36,936.188Zm-3.763-.63A1.537,1.537,0,0,0-744.8,937.4a1.53,1.53,0,0,0,1.849-1.307,1.52,1.52,0,0,0-1.322-1.838A1.53,1.53,0,0,0-746.124,935.558Z",
    transform: "translate(751.187 -927.851)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34226",
    "data-name": "Path 34226",
    d: "M-677.965,940.887a.087.087,0,0,1,.088-.075l.435.033a.088.088,0,0,1,.075.088l-.159,2.093a1.815,1.815,0,0,1-2.161,1.817,1.818,1.818,0,0,1-1.861-2.123l.159-2.093a.088.088,0,0,1,.088-.076l.435.033a.088.088,0,0,1,.075.088l-.159,2.093a1.289,1.289,0,0,0,1.3,1.561,1.283,1.283,0,0,0,1.524-1.347Z",
    transform: "translate(691.283 -934.143)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34227",
    "data-name": "Path 34227",
    d: "M-623.012,944.618l0-.327a.116.116,0,0,1,.095-.1l3.83-.024a.116.116,0,0,1,.1.095l0,.327a.117.117,0,0,1-.095.1l-1.615.01.022,3.489a.088.088,0,0,1-.081.082l-.436,0a.088.088,0,0,1-.082-.081l-.022-3.489-1.615.01A.115.115,0,0,1-623.012,944.618Z",
    transform: "translate(637.488 -937.47)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34228",
    "data-name": "Path 34228",
    d: "M-561.638,943.566a.088.088,0,0,1-.074.089l-.435.038a.088.088,0,0,1-.088-.074l-.138-1.575-2.81.247.138,1.575a.088.088,0,0,1-.074.089l-.435.038a.088.088,0,0,1-.089-.075l-.343-3.91a.088.088,0,0,1,.074-.088l.434-.038a.088.088,0,0,1,.089.074l.159,1.819,2.81-.247-.16-1.819a.088.088,0,0,1,.074-.089l.434-.038a.088.088,0,0,1,.089.074Z",
    transform: "translate(585.086 -933.253)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34229",
    "data-name": "Path 34229",
    d: "M-486.576,923.1l-.186.042-1.791-2.464a1.327,1.327,0,0,1-.079-.136l-.013,0a1.357,1.357,0,0,1-.014.157l-.577,2.991-.186.041-2.751-3.45a.229.229,0,0,1-.044-.074c0-.02,0-.043.044-.052l.466-.1c.08-.018.092-.028.151.05l1.638,2.057a4.791,4.791,0,0,1,.335.533l.027-.006a5.036,5.036,0,0,1,.064-.559l.512-2.683.186-.042,1.6,2.212a5.023,5.023,0,0,1,.3.479l.026-.006a4.8,4.8,0,0,1,.077-.625l.61-2.558c.021-.1.035-.092.115-.109l.466-.1c.04-.009.058.008.062.028a.227.227,0,0,1-.009.085Z",
    transform: "translate(517.302 -914.06)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34230",
    "data-name": "Path 34230",
    d: "M-402.5,906.679l.415,1.269,2.46-.8a.115.115,0,0,1,.12.061l.1.311a.116.116,0,0,1-.061.12l-2.952.966a.088.088,0,0,1-.1-.052l-1.22-3.73a.088.088,0,0,1,.052-.1l2.888-.945a.115.115,0,0,1,.12.061l.1.311a.116.116,0,0,1-.061.12l-2.4.784.373,1.14,2.2-.721a.116.116,0,0,1,.12.061l.1.311a.116.116,0,0,1-.061.12Z",
    transform: "translate(435.999 -900.344)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34231",
    "data-name": "Path 34231",
    d: "M-353.665,892.607c.069-.028.1,0,.124.052.192.466.644.634,1.5.282.781-.321.924-.762.761-1.16-.093-.227-.324-.412-.85-.24l-1.083.357c-.788.25-1.269.05-1.486-.479-.236-.574.009-1.4,1.111-1.849,1.172-.481,1.815-.119,2.081.53.013.032,0,.073-.069.1l-.372.153c-.063.026-.1.017-.138-.068-.166-.315-.568-.54-1.305-.237-.649.267-.919.739-.754,1.142.093.227.325.36.785.208l1.065-.349c.892-.286,1.368.012,1.57.5.21.51.066,1.38-1.119,1.866-1.153.474-1.962.172-2.234-.489l-.026-.063c-.018-.044-.01-.077.047-.1Z",
    transform: "translate(391.011 -887.093)",
    fill: "#a6acba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34232",
    "data-name": "Path 34232",
    d: "M-315.485,863.679l-.145-.293a.116.116,0,0,1,.043-.128l3.429-1.7a.116.116,0,0,1,.128.043l.146.293a.116.116,0,0,1-.043.128l-1.446.718,1.552,3.124a.088.088,0,0,1-.037.109l-.39.194a.088.088,0,0,1-.11-.036L-313.911,863l-1.446.718A.115.115,0,0,1-315.485,863.679Z",
    transform: "translate(355.042 -861.549)",
    fill: "#a6acba"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34233",
    "data-name": "Path 34233",
    d: "M-888.435,454.4l-1.779.852-1.193,6.614-.514,2.849c.247.139.5.279.758.418a46.529,46.529,0,0,0,10.126,3.985l-2.492-15.341h.49s.36-6.179-2.288-6.179a1.546,1.546,0,0,0-1.242.556l-4.283.883s-1.8.719-1.373,4.543Z",
    transform: "translate(900.519 -428.942)",
    fill: "#00afec",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34234",
    "data-name": "Path 34234",
    d: "M-437.3,563.846c.585-.433,1.141-.867,1.667-1.3l.076-.929-12.78-4.42v12.445l.006,0A39.36,39.36,0,0,0-437.3,563.846Z",
    transform: "translate(492.579 -529.654)",
    fill: "#4f9f28",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34235",
    "data-name": "Path 34235",
    d: "M-576.925,395.521l.514-.172V388.32h-2.495v-1.759l-1.6-1.6-.4-13.692-1.581-1.329h1.542l-.071-2.424H-583.3l-.514,17.445-1.6,1.6v1.759h-2.307v8.88A36.439,36.439,0,0,0-576.925,395.521Z",
    transform: "translate(620.65 -355.358)",
    fill: "#cc006c",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24639",
    "data-name": "Group 24639",
    transform: "translate(12.025 30.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24638",
    "data-name": "Group 24638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34236",
    "data-name": "Path 34236",
    d: "M-845.463,603.046a.082.082,0,0,1-.034-.1l1.651-3.279a.082.082,0,0,1,.1-.034l1.748.88c.774.39.978,1.006.711,1.536a.894.894,0,0,1-.62.494l-.006.011a1.015,1.015,0,0,1,.026,1.012c-.33.654-.994.784-1.814.371Zm2.012.2c.432.218.672.167.81-.106.126-.25.019-.519-.408-.734l-.962-.485-.419.831Zm.087-2.611-.35.695.991.5c.341.172.541.073.633-.109s.024-.43-.34-.614Z",
    transform: "translate(845.504 -599.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34237",
    "data-name": "Path 34237",
    d: "M-795.2,623.535l-.3.813,2.1.784a.108.108,0,0,1,.052.115l-.192.514a.108.108,0,0,1-.115.052l-2.843-1.059a.082.082,0,0,1-.045-.1l1.282-3.441a.082.082,0,0,1,.1-.045l2.807,1.046a.109.109,0,0,1,.053.115l-.192.514a.108.108,0,0,1-.115.052l-2.067-.77-.272.729,1.887.7a.108.108,0,0,1,.052.115l-.191.514a.109.109,0,0,1-.115.053Z",
    transform: "translate(800.516 -619.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34238",
    "data-name": "Path 34238",
    d: "M-747.155,641.747a.111.111,0,0,1,.1.124c-.019.331.2.6.783.746s.915,0,.983-.269c.044-.173-.04-.359-.4-.484l-.943-.326c-.738-.254-1.051-.7-.909-1.258.164-.642.878-1.092,1.971-.812,1.13.289,1.49.94,1.339,1.532a.111.111,0,0,1-.144.075l-.612-.156a.1.1,0,0,1-.087-.121c.018-.226-.138-.489-.682-.628-.519-.133-.863,0-.932.275-.043.167.037.319.37.43l.937.325c.846.295,1.075.814.944,1.327-.148.58-.814,1.1-2.012.8-1.13-.289-1.617-.986-1.461-1.6l.013-.049a.116.116,0,0,1,.146-.081Z",
    transform: "translate(755.854 -636.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34239",
    "data-name": "Path 34239",
    d: "M-697.9,647.8a.109.109,0,0,1-.075-.1l.081-.542a.108.108,0,0,1,.1-.075l3.58.537a.108.108,0,0,1,.075.1l-.081.542a.108.108,0,0,1-.1.075l-1.362-.2-.448,2.988a.082.082,0,0,1-.087.064l-.706-.106a.082.082,0,0,1-.064-.087l.448-2.987Z",
    transform: "translate(709.938 -643.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34240",
    "data-name": "Path 34240",
    d: "M-627.264,656.488a1.99,1.99,0,0,1-2.1,1.987,1.99,1.99,0,0,1-2.12-1.965,2,2,0,0,1,2.1-1.987A2,2,0,0,1-627.264,656.488Zm-3.353.017a1.2,1.2,0,0,0,1.249,1.243,1.2,1.2,0,0,0,1.237-1.256,1.2,1.2,0,0,0-1.249-1.243A1.2,1.2,0,0,0-630.617,656.5Z",
    transform: "translate(648.844 -650.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34241",
    "data-name": "Path 34241",
    d: "M-572.035,654.115a.082.082,0,0,1-.085-.067l-.43-3.647a.082.082,0,0,1,.067-.085l2.849-.336a.108.108,0,0,1,.1.078l.064.544a.108.108,0,0,1-.078.1l-2.064.244.112.95,1.849-.218a.109.109,0,0,1,.1.078l.064.544a.108.108,0,0,1-.078.1l-1.849.218.157,1.329a.082.082,0,0,1-.067.085Z",
    transform: "translate(594.69 -645.895)",
    fill: "#fff"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34242",
    "data-name": "Path 34242",
    d: "M-704.956,455.369l14.738,4.828-1.1,1.7-13.634-4.181",
    transform: "translate(728.381 -436.084)",
    fill: "#e95a00",
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34243",
    "data-name": "Path 34243",
    d: "M-690.439,402.556l-14.518-5.151v4.7l12.852,4.224Z",
    transform: "translate(728.381 -382.822)",
    fill: "#f58500",
    opacity: 0.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 2.967,
    cy: 4.122,
    rx: 2.967,
    ry: 4.122,
    transform: "translate(24.511 16.382) rotate(-51.739)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestOfLondonLogo);
export default __webpack_public_path__ + "static/media/best-of-london-logo.fbb21ba0258f8ae9009b216123d2a6c3.svg";
export { ForwardRef as ReactComponent };